document.addEventListener('DOMContentLoaded', () => {
  let selectedItems = [];
  const selectBtnsSelector = '.combo-select-btn';
  
  function getCartEl() {
    return window.vrvCartAddHelpers ? window.vrvCartAddHelpers.getCartElement() : document.querySelector('cart-drawer');
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest(selectBtnsSelector);
    if (!btn) return;
    
    if (btn.disabled && !btn.classList.contains('selected')) return; // Ignore sold out buttons
    
    const card = btn.closest('.combo-product-card');
    if (!card) return;
    
    const variantId = card.dataset.variantId;
    const imageUrl = card.dataset.image;
    
    const currentSlots = document.querySelectorAll('.combo-slot');
    const MAX_ITEMS = currentSlots.length > 0 ? currentSlots.length : 2;

    // Check if already selected -> remove it
    if (selectedItems.find(item => item.id === variantId)) {
      selectedItems = selectedItems.filter(item => item.id !== variantId);
      updateUI();
      return;
    }
    
    if (selectedItems.length >= MAX_ITEMS) {
      alert(`You have already selected ${MAX_ITEMS} items. Remove an item to add a new one.`);
      return;
    }
    
    selectedItems.push({ id: variantId, image: imageUrl });
    updateUI();
  });
  
  function updateUI() {
    const slots = document.querySelectorAll('.combo-slot');
    const MAX_ITEMS = slots.length > 0 ? slots.length : 2;
    const addToCartBtn = document.querySelector('.combo-add-to-cart');
    const activeIndex = selectedItems.length;

    slots.forEach((slot, index) => {
      const item = selectedItems[index];
      const wrapper = slot.closest('.combo-slot-wrapper');
      const labelSub = wrapper ? wrapper.querySelector('.combo-slot-sub') : null;
      const labelName = wrapper ? wrapper.querySelector('.combo-slot-name') : null;
      
      slot.innerHTML = '';
      
      if (item) {
        // STATE A: FILLED / SELECTED
        slot.className = 'combo-slot filled';
        if (wrapper) wrapper.className = 'combo-slot-wrapper filled';
        
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = `Item ${index + 1}`;
        slot.appendChild(img);
        
        const removeBtn = document.createElement('button');
        removeBtn.className = 'combo-slot-remove';
        removeBtn.setAttribute('aria-label', `Remove Item ${index + 1}`);
        removeBtn.innerHTML = '×';
        removeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          selectedItems.splice(index, 1);
          updateUI();
        });
        slot.appendChild(removeBtn);
        
        if (labelSub) labelSub.textContent = 'select your';
        if (labelName) {
          labelName.textContent = `Item ${index + 1}`;
          labelName.className = 'combo-slot-name selected-text';
        }
      } else if (index === activeIndex) {
        // STATE B: ACTIVE NEXT STEP (GREEN HIGHLIGHT)
        slot.className = 'combo-slot active';
        if (wrapper) wrapper.className = 'combo-slot-wrapper active';
        
        const numSpan = document.createElement('span');
        numSpan.className = 'combo-slot-num';
        numSpan.textContent = `${index + 1}`;
        slot.appendChild(numSpan);
        
        if (labelSub) labelSub.textContent = 'select your';
        if (labelName) {
          labelName.textContent = `Item ${index + 1}`;
          labelName.className = 'combo-slot-name active-text';
        }
      } else {
        // STATE C: UPCOMING UNSELECTED STEP
        slot.className = 'combo-slot';
        if (wrapper) wrapper.className = 'combo-slot-wrapper';
        
        const numSpan = document.createElement('span');
        numSpan.className = 'combo-slot-num';
        numSpan.textContent = `${index + 1}`;
        slot.appendChild(numSpan);
        
        if (labelSub) labelSub.textContent = 'select your';
        if (labelName) {
          labelName.textContent = `Item ${index + 1}`;
          labelName.className = 'combo-slot-name';
        }
      }
    });
    
    const allBtns = document.querySelectorAll(selectBtnsSelector);
    allBtns.forEach(btn => {
      const card = btn.closest('.combo-product-card');
      if(!card) return;
      const variantId = card.dataset.variantId;
      
      if (selectedItems.find(item => item.id === variantId)) {
        btn.classList.add('selected');
        if (btn.classList.contains('vrv-plix-add-to-box-btn')) {
           btn.innerHTML = 'SELECTED';
        } else {
           btn.innerText = 'Selected';
        }
      } else {
        btn.classList.remove('selected');
        if(!btn.disabled || btn.classList.contains('selected')){
            if (btn.classList.contains('vrv-plix-add-to-box-btn')) {
               btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg> ADD TO COMBO';
            } else {
               btn.innerText = 'Select';
            }
        }
      }
    });
    
    if (addToCartBtn) {
      addToCartBtn.disabled = selectedItems.length !== MAX_ITEMS;
    }
  }

  // Popup Logic
  const popupOverlay = document.getElementById('vrv-plix-popup');
  if (popupOverlay) {
    const popupCloseBtn = popupOverlay.querySelector('.vrv-plix-popup-close');
    const popupTitle = document.getElementById('vrv-plix-popup-title');
    const popupImageContainer = document.getElementById('vrv-plix-popup-image-container');
    const popupAddBtn = document.getElementById('vrv-plix-popup-add-btn');
    
    document.addEventListener('click', (e) => {
      const isImgClick = e.target.closest('.vrv-img-hover-trigger .vrv-img-hover__link');
      const isTitleClick = e.target.closest('[class*="luxury-product-title-"] span');
      const isLearnClick = e.target.closest('.vrv-plix-learn-btn');
      
      if (isImgClick || isTitleClick || isLearnClick) {
        e.preventDefault();
        const card = e.target.closest('.combo-product-card');
        if (!card) return;
        
        const variantId = card.dataset.variantId;
        
        const titleEl = card.querySelector('[class*="luxury-product-title-"]');
        const priceEl = card.querySelector('[class*="luxury-current-price-"]');
        
        if (titleEl) popupTitle.innerText = titleEl.innerText;
        
        if (popupImageContainer) {
          popupImageContainer.innerHTML = '';
          const dotsContainer = document.getElementById('vrv-plix-popup-image-dots');
          const prevBtn = document.getElementById('vrv-plix-popup-prev');
          const nextBtn = document.getElementById('vrv-plix-popup-next');
          
          if (dotsContainer) dotsContainer.innerHTML = '';
          
          try {
            const images = JSON.parse(card.dataset.images || '[]');
            if (images.length > 0) {
              images.forEach((src, idx) => {
                const img = document.createElement('img');
                img.src = src;
                img.className = 'vrv-plix-popup-scroll-img';
                popupImageContainer.appendChild(img);
                
                if (dotsContainer) {
                  const dot = document.createElement('div');
                  dot.className = 'vrv-plix-popup-dot' + (idx === 0 ? ' active' : '');
                  dotsContainer.appendChild(dot);
                }
              });
              
              if (images.length > 1) {
                if (prevBtn) {
                   prevBtn.style.display = 'flex';
                   prevBtn.onclick = () => popupImageContainer.scrollBy({left: -110, behavior: 'smooth'});
                }
                if (nextBtn) {
                   nextBtn.style.display = 'flex';
                   nextBtn.onclick = () => popupImageContainer.scrollBy({left: 110, behavior: 'smooth'});
                }
                
                popupImageContainer.onscroll = () => {
                  if (!dotsContainer) return;
                  const scrollLeft = popupImageContainer.scrollLeft;
                  const width = popupImageContainer.offsetWidth;
                  const activeIdx = Math.round(scrollLeft / width);
                  const dots = dotsContainer.querySelectorAll('.vrv-plix-popup-dot');
                  dots.forEach((d, i) => {
                    if (i === activeIdx) d.classList.add('active');
                    else d.classList.remove('active');
                  });
                };
              } else {
                if (prevBtn) prevBtn.style.display = 'none';
                if (nextBtn) nextBtn.style.display = 'none';
                popupImageContainer.onscroll = null;
              }
              
            } else {
               const img = document.createElement('img');
               img.src = card.dataset.image;
               img.className = 'vrv-plix-popup-scroll-img';
               popupImageContainer.appendChild(img);
               if (prevBtn) prevBtn.style.display = 'none';
               if (nextBtn) nextBtn.style.display = 'none';
               popupImageContainer.onscroll = null;
            }
          } catch(e) {
             const img = document.createElement('img');
             img.src = card.dataset.image;
             img.className = 'vrv-plix-popup-scroll-img';
             popupImageContainer.appendChild(img);
             if (prevBtn) prevBtn.style.display = 'none';
             if (nextBtn) nextBtn.style.display = 'none';
             popupImageContainer.onscroll = null;
          }
        }
        
        popupAddBtn.dataset.variantId = variantId;
        
        if (selectedItems.find(item => item.id === variantId)) {
           popupAddBtn.innerText = 'SELECTED';
        } else {
           popupAddBtn.innerHTML = '<span id="vrv-plix-popup-price" style="position: absolute; left: 15px;">' + (priceEl ? priceEl.innerText : '') + '</span> Add To Combo';
        }
        
        popupOverlay.style.display = 'flex';
        document.body.style.overflow = 'hidden';
      }
    });
    
    if (popupCloseBtn) {
      popupCloseBtn.addEventListener('click', () => {
        popupOverlay.style.display = 'none';
        document.body.style.overflow = '';
      });
    }
    
    popupOverlay.addEventListener('click', (e) => {
      if (e.target === popupOverlay) {
        popupOverlay.style.display = 'none';
        document.body.style.overflow = '';
      }
    });
    
    if (popupAddBtn) {
      popupAddBtn.addEventListener('click', () => {
        const variantId = popupAddBtn.dataset.variantId;
        if (!variantId) return;
        
        const card = document.querySelector(`.combo-product-card[data-variant-id="${variantId}"]`);
        if (card) {
          const selectBtn = card.querySelector('.combo-select-btn');
          if (selectBtn) {
             selectBtn.click();
             popupOverlay.style.display = 'none';
             document.body.style.overflow = '';
          }
        }
      });
    }
  }
  
  // FIX ("Please try again in a few minutes" / "Could not add to cart" on Add
  // to Combo): two distinct transient causes, both handled here instead of
  // just surfacing the alert:
  //   1) A cart-write collision -- Shopify's own /cart/add.js response when
  //      this write races the background combo-discount sync
  //      (assets/vrv-combo-1699.js), which issues its own /cart/update.js
  //      calls whenever it detects the cart changed. Message-text based.
  //   2) HTTP 429 -- this collection page (grid + filters + the combo
  //      background sync) generates enough request volume that Cloudflare's
  //      rate limiter can kick in and block *everything* for a short window,
  //      including this add-to-cart call. Cloudflare's 429 response is an
  //      HTML block page, not JSON, so it never has a description/message to
  //      pattern-match -- has to be detected from the HTTP status itself
  //      (see the `status` field vrv-add-to-cart.js's fetchCartAddItems now
  //      returns). A 429 needs real wall-clock time to clear, so it gets a
  //      longer, growing backoff instead of the flat retry used for case 1.
  // waitForComboSyncIdle() below also reduces how often case 1 happens in the
  // first place. If it still fails after retrying, the real error is shown,
  // unchanged from before -- no hiding, no hardcoded prices.
  const TRANSIENT_CART_ERROR_PATTERN = /try again|please retry|temporarily unavailable/i;

  function isTransientCartError(data, status) {
    if (status === 429) return true;
    const msg = String((data && (data.description || data.message)) || '');
    return TRANSIENT_CART_ERROR_PATTERN.test(msg);
  }

  function waitForComboSyncIdle() {
    if (typeof window.vrvEnsureComboSynced === 'function') {
      return window.vrvEnsureComboSynced().catch(() => null);
    }
    return Promise.resolve();
  }

  function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function addComboItemsWithRetry(items, cartEl, attemptsLeft, attemptNum) {
    const attempt = attemptNum || 0;
    return window.vrvCartAddHelpers.fetchCartAddItems(items, cartEl).then(({ ok, status, data }) => {
      if (!ok && isTransientCartError(data, status) && attemptsLeft > 0) {
        const wait = status === 429 ? 1500 * Math.pow(2, attempt) : 700;
        return delay(wait).then(() => addComboItemsWithRetry(items, cartEl, attemptsLeft - 1, attempt + 1));
      }
      if (!ok && status === 429 && (!data || (!data.description && !data.message))) {
        return { ok, data: Object.assign({}, data, { description: 'Too many requests right now. Please wait a moment and try again.' }) };
      }
      return { ok, data };
    });
  }

  document.addEventListener('click', (e) => {
    const addToCartBtn = e.target.closest('.combo-add-to-cart');
    if (!addToCartBtn) return;

    const currentSlots = document.querySelectorAll('.combo-slot');
    const MAX_ITEMS = currentSlots.length > 0 ? currentSlots.length : 2;

    if (selectedItems.length !== MAX_ITEMS) return;

    const comboId = 'combo_' + Date.now();
    const items = selectedItems.map(item => ({
      id: item.id,
      quantity: 1,
      properties: {
        'VrvComboId': comboId
      }
    }));

    const originalText = addToCartBtn.innerText;
    addToCartBtn.innerText = 'Adding...';
    addToCartBtn.disabled = true;
    const cartEl = getCartEl();

    if (window.vrvCartAddHelpers && window.vrvCartAddHelpers.fetchCartAddItems) {
      waitForComboSyncIdle()
        .then(() => addComboItemsWithRetry(items, cartEl, 2))
        .then(({ ok, data }) => {
          if (!ok) {
            alert(data.description || data.message || 'Could not add to cart');
          } else {
             window.vrvCartAddHelpers.syncCartUi(cartEl, data, addToCartBtn);
             // Dispatch empty cart:updated so vrv-combo-1699 fetches the true full cart
             document.dispatchEvent(new CustomEvent('cart:updated', { detail: {} }));
             selectedItems = [];
             updateUI();
          }
          addToCartBtn.innerText = originalText;
          addToCartBtn.disabled = false;
        })
        .catch(err => {
          console.error(err);
          alert('Error adding to cart');
          addToCartBtn.innerText = originalText;
          addToCartBtn.disabled = false;
        });
    } else {
      // Fallback if vrvCartAddHelpers is not loaded
      fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(response => response.json())
      .then(data => {
        addToCartBtn.innerText = originalText;
        addToCartBtn.disabled = false;
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (cartEl && typeof cartEl.open === 'function') {
          cartEl.open();
        } else if (document.querySelector('cart-drawer')) {
          document.querySelector('cart-drawer').open();
        }
        selectedItems = [];
        updateUI();
      })
      .catch(error => {
        alert('There was an error adding the items to the cart.');
        addToCartBtn.innerText = originalText;
        addToCartBtn.disabled = false;
      });
    }
  });
  
  // Initial UI Setup
  updateUI();
});
